import { render, staticRenderFns } from "./complaints-summary.pug?vue&type=template&id=dbe0ac14&scoped=true&lang=pug&external"
import script from "./complaints-summary.js?vue&type=script&lang=js&external"
export * from "./complaints-summary.js?vue&type=script&lang=js&external"
import style0 from "./complaints-summary.scss?vue&type=style&index=0&id=dbe0ac14&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe0ac14",
  null
  
)

export default component.exports